// extracted by mini-css-extract-plugin
module.exports = {"tagListWrapper":"styles_tagListWrapper__1RCiS","tagListWrapperNoTags":"styles_tagListWrapperNoTags__2Kw41"};